/**
 *
 * @module accessContextState
 *
 */

/**
 *
 * @class AccessContextState
 *
 */
export default class AccessContextState {

    /**
     *
     * @param {Array} [modes=[]]
     *
     */
    constructor(modes = []) {

        /**
         *
         * @access private
         * @type {Array}
         * @desc Array of strings representing enabled / authenticated providers
         *
         */
        this.modes = modes;

    }

    /**
     *
     * @access public
     * @param {String} mode
     * @returns {Boolean}
     *
     */
    hasMode(mode) {

        return this.modes.includes(mode);

    }

}



// WEBPACK FOOTER //
// ./src/token/accessContextState.js